export default class CreatEditAdminViewModel {
    public id: string | null = null;
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
}